/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {
  constructor() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#Facets-Toggle');
      if (!btn) return;

      e.preventDefault();

      const body = document.body;
      const container = document.getElementById('Facet-Drawer');
      body.classList.toggle('open-cc');
      if (container) container.classList.toggle('active');
    }, false);
  }
}

class FilterOptionTooltip {
  constructor() {
    this.activeTrigger = null;
    this.modal = null;
    this.registry = null;
    this.dialog = null;
    this.content = null;
    this.title = null;

    document.addEventListener('click', this.handleDocumentClick.bind(this));
    document.addEventListener('pointerdown', this.handlePointerDown.bind(this));
    document.addEventListener('keydown', this.handleKeydown.bind(this));
    this.refreshElements();
  }

  refreshElements() {
    this.modal = document.querySelector('[data-filter-option-tooltip-modal]');
    this.registry = document.querySelector('[data-filter-option-tooltip-registry]');

    if (!this.modal || !this.registry) {
      this.dialog = null;
      this.content = null;
      this.title = null;
      return false;
    }

    this.dialog = this.modal.querySelector('[data-filter-option-tooltip-dialog]');
    this.content = this.modal.querySelector('[data-filter-option-tooltip-content]');
    this.title = this.modal.querySelector('#FilterOptionTooltipTitle');
    return Boolean(this.dialog && this.content && this.title);
  }

  handlePointerDown(event) {
    if (!event.target.closest('[data-filter-option-tooltip-trigger]')) return;

    event.stopPropagation();
  }

  handleDocumentClick(event) {
    this.refreshElements();

    const trigger = event.target.closest('[data-filter-option-tooltip-trigger]');
    const closeButton = event.target.closest('[data-filter-option-tooltip-close]');

    if (trigger) {
      if (!this.modal || !this.registry) return;

      event.preventDefault();
      event.stopPropagation();

      this.open(trigger);
      return;
    }

    if (closeButton) {
      event.preventDefault();
      this.close();
      return;
    }

    if (this.modal && !this.modal.hidden && !event.target.closest('[data-filter-option-tooltip-dialog]')) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.modal && !this.modal.hidden) {
      this.close();
    }
  }

  open(trigger) {
    if (!this.refreshElements()) return;

    const tooltipKey = trigger.dataset.tooltipKey;
    const template = Array.from(
      this.registry.querySelectorAll('[data-filter-option-tooltip-template]')
    ).find((item) => item.dataset.tooltipKey === tooltipKey);

    if (!template) return;

    if (this.activeTrigger) {
      this.activeTrigger.setAttribute('aria-expanded', 'false');
    }

    this.activeTrigger = trigger;
    this.activeTrigger.setAttribute('aria-expanded', 'true');
    this.title.textContent = trigger.dataset.tooltipTitle || '';
    this.content.innerHTML = '';
    this.content.appendChild(template.content.cloneNode(true));
    this.modal.hidden = false;
    this.modal.classList.add('is-visible');
    document.body.classList.add('overflow-hidden');
    this.dialog.focus();
  }

  close() {
    if (!this.modal) return;

    if (this.activeTrigger) {
      this.activeTrigger.setAttribute('aria-expanded', 'false');
      this.activeTrigger.focus();
    }

    this.activeTrigger = null;
    this.modal.hidden = true;
    this.modal.classList.remove('is-visible');
    document.body.classList.remove('overflow-hidden');
    this.content.innerHTML = '';
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
  
    const debouncePriceInput = debounce((event) => {
      this.onSubmitHandler(event);
    }, 1200);
  
    this.querySelector('form').addEventListener('input', (event) => {

      if (
        event.target.id === 'Filter-Precio-GTE' || 
        event.target.id === 'Filter-Precio-LTE'
      ) {
        debouncePriceInput(event);
      } else {
        this.onSubmitHandler(event);
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    if (window.filterOptionTooltip) window.filterOptionTooltip.close();
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

const initializeFacetEnhancements = () => {
  if (!window.facetsToggle) {
    window.facetsToggle = new FacetsToggle();
  }

  if (!window.filterOptionTooltip) {
    window.filterOptionTooltip = new FilterOptionTooltip();
  } else {
    window.filterOptionTooltip.refreshElements();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFacetEnhancements);
} else {
  initializeFacetEnhancements();
}
